import { Gem, Cpu, Feather } from "lucide-react";

const pillars = [
  {
    icon: Gem,
    title: "Belleza personalizada",
    text: "Cada tratamiento se adapta a tu piel, tu ritmo y tus objetivos concretos.",
  },
  {
    icon: Cpu,
    title: "Tecnología estética",
    text: "Trabajamos con equipos avanzados para conseguir resultados naturales.",
  },
  {
    icon: Feather,
    title: "Bienestar y confianza",
    text: "Un espacio cuidado donde cada visita se convierte en un ritual íntimo.",
  },
];

const Positioning = () => (
  <section
    data-testid="positioning-section"
    className="py-24 md:py-32"
    style={{ background: "#FBF6F2" }}
  >
    <div className="max-w-6xl mx-auto px-5 sm:px-8 text-center">
      <span className="laka-eyebrow">Nuestra esencia</span>
      <h2 className="mt-6 font-serif-laka text-4xl md:text-5xl lg:text-6xl font-light leading-[1.08] text-[#1A1A1A] max-w-4xl mx-auto">
        Donde la belleza <span className="italic text-[#D6B36A]">se convierte</span> en bienestar
      </h2>
      <p className="mt-8 text-[#1A1A1A]/70 max-w-2xl mx-auto leading-relaxed font-light">
        En LAKA CLUB BEAUTY diseñamos cada tratamiento desde la escucha, la
        tecnología y el cuidado del detalle. Nuestro objetivo es ayudarte a
        mejorar tu imagen de forma natural, elegante y personalizada.
      </p>

      <div className="mt-16 grid md:grid-cols-3 gap-8 md:gap-10 text-left">
        {pillars.map(({ icon: Icon, title, text }, i) => (
          <div
            key={title}
            data-testid={`pillar-${i}`}
            className="p-8 laka-card"
          >
            <span className="inline-flex items-center justify-center w-11 h-11 border border-[#D6B36A]/60 rounded-full">
              <Icon className="w-5 h-5 text-[#D6B36A]" strokeWidth={1.3} />
            </span>
            <h3 className="mt-6 font-serif-laka text-2xl text-[#1A1A1A]">
              {title}
            </h3>
            <p className="mt-3 text-sm text-[#1A1A1A]/70 leading-relaxed font-light">
              {text}
            </p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Positioning;
